import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setGetCashiersProfile } from '../../store/thunk/setGetCashiersProfile';
import TableCasino from '../../../../../@casino/ui/table';
import {columns, getRows, useStyles} from './helpers/index';
import Title from '../../../../../@casino/ui/title';
import {useFormik, FormikContext} from "formik";
import Switch from '@material-ui/core/Switch';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const ReportBalance = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const [order, setOrder] = React.useState('id');
    const [desc, setDesc] = React.useState(false);
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetCashiersProfile({
            page: 1,
            rowsPerPage: 10,
            order: 'id',
            desc: false,
            search: '',
            date_from: 0,
            date_to: new Date().getTime(),
        }));
    }, []);

    const cashiers = useSelector(state => state.report_balance.cashiers);
    const rows = React.useMemo(() => getRows(cashiers), [cashiers]);

    const initialValues = {
        check: false,
        search: '',
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});

    return (
        <div className={classes.root}>
            <Title label="Отчет по балансам" />
            
            <div className={classes.wrap} style={{display: 'flex', alignItems: 'center'}}>
                <FormikContext.Provider value={formik}>
                    <form>
                        <div style={{
                            paddingLeft: 20,
                            background: '#1b2039', 
                            borderRadius: 8, 
                
                        }}>
                            <div style={{display: 'flex', marginRight: 12}}>
                                <label htmlFor="check" className={classes.wrapSwitch}>
                                    <span className={classes.manually}>Ручн. время</span>
                                    <Switch
                                        checked={formik.values.check}
                                        onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                        color="primary"
                                        name="checkedB"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </label>
                                <span className={classes.spo}>С</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    className={classes.datetime}
                                    value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(0);
                                            date.setMinutes(0);
                                            date.setSeconds(0);
                                            date.setMilliseconds(0);
                                        }

                                        formik.setFieldValue('date_from', date.getTime());

                                        dispatch(setGetCashiersProfile({
                                            page: 1,
                                            rowsPerPage: 10,
                                            order: 'id',
                                            desc: false,
                                            search,
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                        }))
                                    }}
                                />
                                <span className={classes.spo}>ПО</span>
                                <input 
                                    type={formik.values.check ? 'datetime-local' : 'date' }
                                    style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                    value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                    onChange={(v) => {
                                        const date = new Date(v.target.value);
                                        if (!formik.values.check) {
                                            date.setHours(23);
                                            date.setMinutes(59);
                                            date.setSeconds(59);
                                            date.setMilliseconds(999);
                                        }

                                        formik.setFieldValue('date_to', date.getTime());

                                        dispatch(setGetCashiersProfile({
                                            page: 1,
                                            rowsPerPage: 10,
                                            order: 'id',
                                            desc: false,
                                            search,
                                            date_from: isNaN(date.getTime()) ? new Date(0).getTime() : formik.values.date_from,
                                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() : date.getTime(),
                                        }))
                                        
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </FormikContext.Provider>
                <input 
                    type="text"
                    placeholder="Поиск"
                    className={classes.search}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGetCashiersProfile({
                            page: 1,
                            rowsPerPage: 10,
                            order: 'id',
                            desc: false,
                            search: v.target.value,
                            date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                        }));
                        setSearch(v.target.value);
                    }}
                />
            </div>
            <div className={classes.wrapBlock}>
                <TableCasino
                    order={(v) => {
                        dispatch(setGetCashiersProfile({
                            page: 1,
                            rowsPerPage: 10,
                            order: v.id,
                            desc: !desc,
                            search,
                            date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                            date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                        }));
                        setOrder(v.id);
                        setDesc(!desc);

                    }}
                    pagination
                    allPage={cashiers.countPage}
                    width={700}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetCashiersProfile({
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                        desc,
                        order,
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetCashiersProfile({
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                        desc,
                        order,
                        search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() :  formik.values.date_to,
                    }))}
                /> 
            </div>
            
        </div>  
    )
}

export default ReportBalance;